import { WebResponse } from "@app/shared/interfaces/webResponse.interface";
import { PortalRequest } from "../interfaces/portalRequest.interface";
import {
  FetchAllSystemUsers,
  FetchAllSystemUsersSuccess,
  FetchCaseContactsSuccess,
  FetchClinicsSuccess,
  FetchPortalRequests,
  FetchPortalRequestsSuccess,
  FetchProvidersSuccess
} from "./admin.actions";
import { createReducer, on } from "@ngrx/store";
import { UserStatusInfo } from "../interfaces/userStatusInfo.interface";
import { PaginatedResult } from "@app/shared/interfaces/paginatedResult.interface";
import { CaseContact } from "@app/shared/interfaces/caseContact.interface";
import { Clinic } from "@app/shared/interfaces/clinic.interface";
import { Provider } from "@app/shared/interfaces/provider.interface";
import { SessionExpired } from "@app/core/store/userAuth/userAuth.actions";

export const adminDashboardFeatureKey = 'adminDashboard';

export interface State {
    loading: boolean;
    unconfirmedPortalRequestsResponse: WebResponse<PortalRequest[]> | null;
    allSystemUsersResponse?: WebResponse<PaginatedResult<UserStatusInfo>> | null;
    caseContacts: CaseContact[];
    clinics: Clinic[];
    providers: Provider[];
}

export const initialState: State = {
    loading: false,
    unconfirmedPortalRequestsResponse: null,
    allSystemUsersResponse: null,
    caseContacts: [],
    clinics: [],
    providers: []
};

export const reducer = createReducer(
    initialState,
    on(FetchPortalRequests, (state) => ({
        ...state,
        loading: true
    })),
    on(FetchPortalRequestsSuccess, (state, { portalRequests }) => ({
        ...state,
        loading: false,
        unconfirmedPortalRequestsResponse: portalRequests
    })),
    on(FetchAllSystemUsers, (state) => ({
        ...state,
        loading: true
    })),
    on(FetchAllSystemUsersSuccess, (state, { users }) => ({
        ...state,
        loading: false,
        allSystemUsersResponse: users
    })),
    on(SessionExpired, (state) => ({
      ...state,
      loading: false
    })),
    on(FetchCaseContactsSuccess, (state, { caseContacts }) => ({
      ...state,
      caseContacts
    })),
    on(FetchClinicsSuccess, (state, { clinics }) => ({
      ...state,
      clinics
    })),
    on(FetchProvidersSuccess, (state, { providers }) => ({
      ...state,
      providers
    }))
);
